import "esbuild-css-modules-plugin-ns-css:src/artifacts/graphic/styles/labels.module.css";

export default {
  "label": "labels-module__label_rw80oG__010",
  "labels": "labels-module__labels_rw80oG__010"
};
      